import { render, staticRenderFns } from "./PagePatientNotice.vue?vue&type=template&id=15577d60&scoped=true"
import script from "./PagePatientNotice.vue?vue&type=script&lang=js"
export * from "./PagePatientNotice.vue?vue&type=script&lang=js"
import style0 from "./PagePatientNotice.vue?vue&type=style&index=0&id=15577d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15577d60",
  null
  
)

export default component.exports